<template>
  <loan-card>
    <template v-slot:header>
      <nav-tabs></nav-tabs>
    </template>
    <template v-slot:body>
      <div class="container px-0">
        <div class="row">
          <div class="col-md-12 border p-3 m-3 bg-light" style="border-radius: 4px;">
            <div class="text-center p-3 mb-4 border-bottom">
              <h4 class="text-muted"><span>Borrower ID</span></h4>
            </div>
            <div class="form-group">
              <label for="respondent-id">Respondent ID</label>
              <input class="form-control" v-model="respondent_id"
                     :class="{ 'is-invalid': v$.respondent_id.$errors.length }" type="text" id="respondent-id"/>
              <div class="invalid-feedback" v-for="error of v$.respondent_id.$errors" :key="error.$uid">
                {{ error.$message }}
              </div>
            </div>
            <div class="list-group mb-3" :class="{ 'border border-danger': v$.subcounty.$errors.length || v$.parish.$errors.length || v$.village.$errors.length }">
              <div class="list-group-item p-0" id="parish-block">
                <locations v-on:subCounty="setLocation" v-on:parish="setLocation" v-on:village="setLocation" position="village" district_prop="1" county_prop="1" :subCounty_prop="subcounty.toString()" :parish_prop="parish.toString()" :village_prop="village.toString()"></locations>
                <input type="hidden" v-model="subcounty"/>
                <input type="hidden" v-model="parish"/>
                <input type="hidden" v-model="village"/>
              </div>
              <!--<div class="list-group-item text-danger" v-for="error of v$.subcounty.$errors" :key="error.$uid">
                {{ error.$message }}
              </div>
              <div class="list-group-item text-danger" v-for="error of v$.parish.$errors" :key="error.$uid">
                {{ error.$message }}
              </div>-->
              <div class="list-group-item text-danger" v-for="error of v$.village.$errors" :key="error.$uid">
                {{ error.$message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <a class="btn btn-primary my-auto ml-auto text-white" href="javascript:void(0)" @click="next">
          Next <i class="mdi mdi-arrow-right"></i>
        </a>
      </div>
    </template>
  </loan-card>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, numeric } from '@vuelidate/validators';
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('loans');
import LoanCard from "./LoanCard";
import NavTabs from "./NavTabs";
import VueChosen from "./VueChosen";
import Locations from "./Locations";
import $ from 'jquery';
import _ from 'lodash';
import Constants from "../constants";
import Firebase from "../firebase";
import moment from 'moment';

export default {
  name: "BorrowerId",
  components: {VueChosen, NavTabs, LoanCard, Locations},
  data() {
    return {
      time: {start: null, end: null},
      respondent_id: '',
      tin: '1',
      gender: 'male',
      age: '',
      license: '1',
      account: '0',
      institution: [],
      statements: '0',
      statements_months: '',
      guarantors: '0',
      guarantor_number: '',
      guarantor_number_clients: '',
      client: '',
      guarantor_institutions: {},
      subcounty: '',
      parish: '',
      village: '',
      treatment: 't2',//
    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  mounted() {
    this.time.start = moment().format();

    Firebase.sendEvent("Borrower requirements tab");
    if (this.personal_requirements || this.loan_requirements)
      this.populate(this.personal_requirements, this.loan_requirements);
  },
  validations () {
    return {
      respondent_id: {required},
      subcounty: {required},
      parish: {required},
      village: {required},
    }
  },
  computed: {
    ...mapState(['locations', 'institutions']),
    ...mapGetters({
      personal_requirements: Constants.GET_PERSONAL,
      loan_requirements: Constants.GET_LOAN,
    }),
    personal() {
      return {
        gender: this.gender,
        age: this.age,
        time: this.time,
        tin: this.tin,
        license: this.license,
        account: this.account,
        institution: this.institution,
        statements: this.statements,
        statements_months: this.statements_months,
        guarantors: this.guarantors !== '0' ? '1' : this.guarantors,
        guarantor_type: this.guarantors,
        guarantor_number: this.guarantor_number,
        guarantor_number_clients: this.guarantor_number_clients,
        client: this.client,
        guarantor_institutions: this.guarantor_institutions,
        subcounty: this.subcounty,
        parish: this.parish,
        village: this.village,
      }
    },
    loan() {
      return {
        house_location: this.house_location,
        business_location: this.business_location,
        time: this.time,
        respondent_id: this.respondent_id,
        loan_size: this.loan_size,
        payment_frequency: this.payment_frequency,
        loan_term: this.loan_term,
        card: this.card,
        loan_type: this.loan_type,
        display_type: this.display_type,
        max_installment: this.max_installment,
        loan_use: this.loan_use,
        business_type: this.business_type,
        business_tenure: this.business_tenure,
        business_records: this.business_records,
        treatment: this.treatment,//set treatment
      }
    },
  },
  methods: {
    ...mapActions([Constants.SET_POSITION, Constants.SET_PERSONAL, Constants.SET_LOAN]),
    next() {
      this.v$.$touch();
      if (this.v$.$error) return;

      this.time.end = moment().format();

      Firebase.sendEvent("Borrower requirements submitted");

      this.SET_PERSONAL(this.personal);
      this.SET_LOAN({requirements: this.loan, position: false});
      this.SET_POSITION(1);
    },
    populate(personal_requirements, loan_requirements) {
      this.respondent_id = loan_requirements.respondent_id;
      this.loan_size = loan_requirements.loan_size;
      this.payment_frequency = loan_requirements.payment_frequency;
      this.loan_term = loan_requirements.loan_term;
      this.card = loan_requirements.card;
      this.loan_type = loan_requirements.loan_type;
      this.display_type = loan_requirements.display_type;
      this.max_installment = loan_requirements.max_installment;
      this.loan_use = loan_requirements.loan_use;
      this.business_type = loan_requirements.business_type;
      this.business_tenure = loan_requirements.business_tenure;
      this.business_records = loan_requirements.business_records;
      this.treatment = loan_requirements.treatment;
      this.tin = personal_requirements.tin;
      this.gender = personal_requirements.gender;
      this.age = personal_requirements.age;
      this.license = personal_requirements.license;
      this.account = personal_requirements.account;
      this.institution = personal_requirements.institution;
      this.statements = personal_requirements.statements;
      this.statements_months = personal_requirements.statements_months;
      this.guarantors = personal_requirements.guarantor_type ? personal_requirements.guarantor_type : personal_requirements.guarantors;
      this.guarantor_number = personal_requirements.guarantor_number;
      this.guarantor_number_clients = personal_requirements.guarantor_number_clients;
      this.client = personal_requirements.client;
      this.guarantor_institutions = personal_requirements.guarantor_institutions;
      this.subcounty = personal_requirements.subcounty;
      this.parish = personal_requirements.parish;
      this.village = personal_requirements.village;
    },
    setLocation(payload) {
      if (payload.subCounty) {
        this.subcounty = payload.subCounty;
      } else {
        this.subcounty = '';
      }
      if (payload.subCounty && payload.parish) {
        this.parish = payload.parish;
      } else {
        this.parish = '';
      }
      if (payload.subCounty && payload.parish && payload.village) {
        this.village = payload.village;
      } else {
        this.village = '';
      }
    },
  },
}
</script>

<style scoped></style>